import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Dollar } from '@/ui/icons/dollar';
import { Legal } from '@/ui/icons/legal';
import { ListItem } from '@/ui/list-item';

export default function ImportantInfo() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View style={{ gap: 8 }}>
        <Text type="title1">Important Information</Text>

        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          Failure to comply with the following policies may result in additional
          fees or deposit forfeiture.
        </Text>
      </View>

      <View style={{ gap: 16 }}>
        <ListItem
          text="Late and overdue"
          caption="A $50/hour late fee applies if the vehicle is not returned on time. Vehicles not returned within 24 hours will be reported as stolen, which may lead to legal consequences and you may be subject to criminal charges."
          icon={
            <Icon
              type="dressed"
              icon={<Legal />}
              fillColor={theme.colors.icon.color}
              width={25}
              height={25}
            />
          }
          onPress={() => {}}
          withBorder={false}
        />

        <ListItem
          text="Parking and Traffic Tickets"
          caption="If you get a ticket while traveling and don't pay before your trip ends, there's a $50 processing fee per unpaid ticket. Please settle tickets promptly to avoid extra charges."
          icon={
            <Icon
              type="dressed"
              icon={<Dollar />}
              fillColor={theme.colors.icon.color}
              width={25}
              height={25}
            />
          }
          onPress={() => {}}
          withBorder={false}
        />

        <ListItem
          text="Deposits"
          caption="Deposits are refunded within 5-10 business days after your trip ends. Processing may take longer if there are outstanding balances or unpaid fees."
          icon={
            <Icon
              type="dressed"
              icon={<Dollar />}
              fillColor={theme.colors.icon.color}
              width={25}
              height={25}
            />
          }
          onPress={() => {}}
          withBorder={false}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    minWidth: '100%',
    gap: 24,
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
